export const AUTO_SAVE_IDLE_ERROR = 'AUTO_SAVE_IDLE_ERROR';
export const AUTO_SAVE_LOCK_ERROR = 'AUTO_SAVE_LOCK_ERROR';
const lockTime = `${
  Number(process.env.REACT_APP_AUTO_SAVE_IDLE_TIME) / 60000
} minutes`;
export const ErrorMessages = {
  AUTO_SAVE_IDLE_ERROR: `You are in view mode because you made no edits for ${lockTime} and {userName} edited the page.`,
  AUTO_SAVE_LOCK_ERROR: `Unable to edit as {userName} is currently editing.`,
};
